"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableCellContainer = exports.TableCell = exports.TableRow = exports.TableHeader = exports.TableBody = exports.Table = void 0;
const stitches_config_1 = require("../../../stitches.config");
const Layout_1 = require("../__styles__/Layout");
exports.Table = (0, stitches_config_1.styled)(Layout_1.FlexColumn, {
    "@media print": {
        pageBreakInside: "avoid",
        breakInside: "avoid",
    },
    variants: {
        spacing: {
            negative: {
                margin: "0 -16px",
                "@lg": {
                    margin: "0 -24px",
                },
            },
            positive: {
                paddingTop: "24px",
            },
        },
    },
});
exports.TableBody = (0, stitches_config_1.styled)("div", {
    lineHeight: "20px",
});
exports.TableHeader = (0, stitches_config_1.styled)("div", {});
exports.TableRow = (0, stitches_config_1.styled)(Layout_1.FlexRow, {
    justifyContent: "space-between",
    maxWidth: "100%",
    "> div:first-child": {
        paddingLeft: "16px",
        textAlign: "left",
        "@lg": {
            paddingLeft: "24px",
        },
    },
    "> div:last-child": {
        paddingRight: "16px",
        "@lg": {
            paddingRight: "24px",
        },
    },
    "> div:not(first-child)": {
        textAlign: "right",
    },
    variants: {
        header: {
            true: {
                "> div": {
                    fontWeight: 500,
                    fontSize: "16px",
                    color: stitches_config_1.colors.contentPrimary,
                    paddingBottom: "16px",
                    paddingTop: "0px",
                },
            },
            false: {
                "&:nth-child(even)": {
                    backgroundColor: stitches_config_1.colors.bgUiList,
                },
            },
        },
    },
    defaultVariants: {
        header: false,
    },
});
exports.TableCell = (0, stitches_config_1.styled)("div", {
    padding: "6px 3px",
    flexBasis: "50%",
    a: {
        textDecoration: "underline",
        cursor: "pointer",
    },
    fontSize: "14px",
    lineHeight: "20px",
    whiteSpace: "nowrap",
    "@mdMax": {
        whiteSpace: "unset",
    },
    variants: {
        wrap: {
            true: {
                whiteSpace: "normal",
            },
        },
        size: {
            narrow: {
                paddingRight: "18px",
            },
            wide: {
                paddingRight: "0px",
            },
        },
        containsTooltip: {
            true: {
                display: "flex",
            },
        },
    },
});
exports.TableCellContainer = (0, stitches_config_1.styled)("div", {
    overflow: "hidden",
    whiteSpace: "normal",
});
//# sourceMappingURL=data:application/json;base64,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